<!-- Compiled at 2026-09-18T12:45:23.821Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: block" [class.fill]="true">
				<div style="display: flex; flex-direction: column; width: 100%" class="fill">
					<mat-toolbar color="primary" [style.flex]="'0 0 auto'">
						<button
							type="button"
							aria-label="Toggle sidenav"
							mat-icon-button
							(click)="toggle_sidebar_206()"
							*ngIf="isHandset$ | async"
						>
							<mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
						</button>
						<div
							class="layout-block fill"
							[style.align-items]="'inherit'"
							[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
							[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
							[style.gap]="'1em'"
						>
							<ng-container *ngIf="!screen.isForExternalUser"
								><button
									class="fill"
									style="margin-left: -12px"
									type="button"
									aria-label="Toggle sidenav"
									mat-icon-button
									(click)="toggle_sidebar_206()"
								>
									<mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
								</button>
							</ng-container>

							<Orders-MainLayoutHeader
								class="fill"
								[$formDirective]="$formDirective"
								[$disabled]="$disabled"
								[$ignoreValidations]="$ignoreValidations"
							>
							</Orders-MainLayoutHeader>
						</div>
					</mat-toolbar>

					<mat-sidenav-container [class]="'theme-lowgile'" [style.flex]="'1 1 auto'">
						<mat-sidenav
							style="width: 19em"
							[fixedInViewport]="false"
							[attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
							[mode]="(isHandset$ | async) ? 'over' : 'side'"
							[opened]="sidebar_206()"
						>
							<div
								class="layout-block vertical"
								[style.align-items]="'inherit'"
								[style.gap]="'0'"
							>
								<Orders-MainLayoutSidebar
									[$formDirective]="$formDirective"
									[$disabled]="$disabled"
									[$ignoreValidations]="$ignoreValidations"
								>
								</Orders-MainLayoutSidebar>
								<div
									class="layout-block"
									[style.flex]="'1 0 auto'"
									[style.align-items]="'inherit'"
									[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
									[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
									[style.gap]="'1em'"
								></div>
								<div
									class="layout-block"
									style="justify-content: center; margin-bottom: 0.5em"
									[style.align-items]="'center'"
									[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
									[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
									[style.gap]="'1em'"
								>
									<span
										style="font-weight: bold"
										[innerHtml]="'powered by' | escapeHtml: 'none' | replaceNewlines: 'span'"
									></span>
									<img
										style="height: 35px"
										[src]="'/studio/assets/logo.svg' | safeUrl"
									/>
								</div>
							</div>
						</mat-sidenav>

						<mat-sidenav-content>
							<div
								class="layout-block vertical fill"
								style="padding: 1em"
								[style.align-items]="'inherit'"
								[style.gap]="'1em'"
							>
								<ng-container
									*ngIf="Sys.User.currentUser || screen.isForExternalUser"
									><div
										class="layout-block grid-vertical fill"
										[style.align-items]="'inherit'"
										[style.--layout-column-count]="2"
										[style.gap]="'0'"
										[style.grid-template-rows]="'auto 1fr'"
									>
										<div
											class="layout-block"
											[style.grid-column]="'span ' + (1)"
											[style.align-items]="'baseline'"
											[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
											[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
											[style.gap]="'1em'"
										>
											<ng-container
												*ngIf="screen.screenTitle || Sys.Process.currentTaskDetails?.taskName"
												><div
													class="layout-block"
													[style.align-items]="'center'"
													[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
													[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
													[style.gap]="'1em'"
												>
													<h2
														[innerHtml]="screen.screenTitle | escapeHtml: 'none' | replaceNewlines: 'h2'"
													></h2>
													<ng-template
														[ngTemplateOutlet]="getContentTemplate('top-right')"
														[ngTemplateOutletContext]="{ $scope, $formDirective, $disabled }"
													></ng-template></div
											></ng-container>

											<ng-container
												*ngIf="Sys.Process.currentTaskDetails?.swimlaneName"
												><span
													[style.flex]="'1 0 auto'"
													[innerHtml]="'' | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span>
												<span
													[innerHtml]="'Your role: ' + Sys.Process.currentTaskDetails?.swimlaneName | escapeHtml: 'none' | replaceNewlines: 'span'"
												></span
											></ng-container>
										</div>
										<div
											class="layout-block vertical"
											style="overflow-y: auto"
											[style.grid-column]="'span ' + (1)"
											[style.align-items]="'inherit'"
											[style.gap]="'1em'"
										>
											<ng-container *ngIf="Sys.Process.isUnassignedTask"
												><div
													class="layout-block"
													[style.align-items]="'inherit'"
													[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
													[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
													[style.gap]="'1em'"
												>
													<button
														mat-raised-button
														class="has-click-handler"
														color="primary"
														style="margin-bottom: 2em"
														(click)="handler_ButtonBlock_179_click_assignToMyself_0($event, { $disabled: $disabled })"
														[disabled]="$disabled"
													>
														<span
															[innerHtml]="Common.$T.assignTaskToMyself | escapeHtml: 'none' | replaceNewlines: 'span'"
														></span>
													</button></div
											></ng-container>

											<ng-container
												*ngrxLet="(!devBarService.isEnableEverything()) && ($disabled || !!($disabled || Sys.Process.isUnassignedTask)) as $disabled"
											>
												<ng-template
													[ngTemplateOutlet]="getContentTemplate('content')"
													[ngTemplateOutletContext]="{ $scope, $formDirective, $disabled }"
												></ng-template>
											</ng-container>
										</div></div
								></ng-container>
							</div>
						</mat-sidenav-content>
					</mat-sidenav-container>
				</div>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
